import React, { useState, useEffect, useContext } from 'react'
import MobileNavigationItem from './MobileNavigationItem'
import { Link } from 'gatsby'
import resolveLink from 'src/utils/resolveLink'
import { PageContext } from 'src/utils/context'
import userIcon from '/static/user.svg'
import { useExtractNavData } from './hooks/useExtractNavData'

const MobileMenu = ({ props, scrolled, setMenuOpen, menuOpen, className }) => {
  const { hasHero } = useContext(PageContext)
  const { navData: extractedNavData } = useExtractNavData({
    data: props.content.header_navigation_v2
  })

  const navData = () => {
    if (!extractedNavData || extractedNavData.length === 0) return []

    return extractedNavData.map(item => {
      return {
        ...item,
        image: item.image,
        open: false,
        navigation_sections: item.navigation_sections || []
      }
    })
  }

  const [data, setData] = useState(navData())

  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'visible'
    }
  }, [open])

  const handleClick = () => {
    setOpen(!open)
    setData(navData())
    setMenuOpen(!open)
  }

  const handleNavItemClick = _uid => {
    setData(data =>
      data.map(item => {
        return {
          ...item,
          open: _uid === item._uid ? !item.open : false,
        }
      }),
    )
  }

  const handleNavLinkClick = _uid => {
    setData(data =>
      data.map(item => {
        return {
          ...item,
          navigation_sections: item.navigation_sections.map(section => {
            return {
              ...section,
              open: _uid === section._uid ? !section.open : false,
            }
          }),
        }
      }),
    )
  }

  return (
    <>
      <div
        className={`md:hidden sm:flex items-center justify-center p-2 pr-0 outline-none focus:outline-none ${className}`}
        onClick={handleClick}
        onKeyDown={handleClick}
        role="button"
        tabIndex="0"
        data-testdata="mobile-menu-button"
      >
        <button
          className={`relative h-[14px] w-[25px] outline-none focus:outline-none`}
        >
          <div
            className={`
                translate-z-0 absolute left-0 h-0.5 -translate-y-1/2 transform-gpu rounded-full transition-all duration-300
                ${
                  open
                    ? 'top-1/2 w-full rotate-[135deg]'
                    : 'top-0 w-4/6 rotate-0'
                }
                ${hasHero && !scrolled ? 'bg-darkblue' : 'bg-darkblue'}
                ${menuOpen ? '!bg-darkblue' : ''}
              `}
          ></div>
          <div
            className={`
                translate-z-0 absolute left-0 h-0.5 w-full -translate-y-1/2 transform-gpu rounded-full transition-all duration-300
                ${open ? 'opacity-0' : 'top-1/2 rotate-0'}
                ${hasHero && !scrolled ? 'bg-darkblue' : 'bg-darkblue'}
              `}
          ></div>
          <div
            className={`
                translate-z-0 absolute left-0 h-0.5 translate-y-1/2 transform-gpu rounded-full transition-all duration-300
                ${
                  open
                    ? 'bottom-1/2 w-full rotate-[-135deg]'
                    : 'bottom-0 w-5/6 rotate-0'
                }
                ${hasHero && !scrolled ? 'bg-darkblue' : 'bg-darkblue'}
                ${menuOpen ? '!bg-darkblue' : ''}
                `}
          ></div>
        </button>
      </div>
      <div
        className={`bg-lightblue !ml-0 !mr-0 lg:hidden ${
          scrolled
            ? 'top-[62px] h-[calc(100vh-62px)]'
            : 'top-[96px] h-[calc(100vh-96px)]'
        } fixed w-screen pt-8 pb-16 transition-all duration-300 ${
          open ? 'left-0' : '-left-full'
        }`}
      >
        <div className="flex h-full flex-col">
          {data.map((item, index) => (
            <>
              {item.navigation_sections?.length > 0 && (
                <MobileNavigationItem
                  {...item}
                  handleNavItemClick={handleNavItemClick}
                  handleNavLinkClick={handleNavLinkClick}
                  scrolled={scrolled}
                  key={index}
                />
              )}

              {(!item.navigation_sections || item.navigation_sections.length === 0) && (
                <>
                  {item.target?.cached_url?.startsWith('https://') ? (
                    <Link
                      to={resolveLink(item.target.cached_url)}
                      target={'_blank'}
                      className="text-darkblue font-display mt-auto flex w-full items-center py-5 px-6 text-xl font-bold leading-5 tracking-[-0.02em] focus:outline-none"
                    >
                      <img className="pl-1" src={userIcon} />
                      {item.name}
                    </Link>
                  ) : (
                    <Link
                      to={resolveLink(item.target.cached_url)}
                      className="text-darkblue flex w-full items-center py-5 px-6 text-xl font-bold font-display leading-5 tracking-[-0.02em]"
                    >
                      {item.name}
                    </Link>
                  )}
                </>
              )}
            </>
          ))}
        </div>
      </div>
    </>
  )
}

export default MobileMenu
